var transform = {
  serializeIn: function serializeIn(_ref) {
    var minValue = _ref.minValue,
        maxValue = _ref.maxValue,
        formatValue = _ref.formatValue;
    return {
      formatValue: typeof formatValue === 'string' ? formatValue : null,
      minValue: minValue,
      maxValue: maxValue
    };
  },
  serializeOut: function serializeOut(_ref2) {
    var minValue = _ref2.minValue,
        maxValue = _ref2.maxValue,
        formatValue = _ref2.formatValue;
    return {
      formatValue: formatValue,
      formatTooltip: formatValue,
      minValue: minValue,
      maxValue: maxValue
    };
  }
};
export default transform;